module.exports = {"431228100":"芷江镇","431228101":"罗旧镇","431228102":"新店坪镇","431228103":"碧涌镇","431228104":"公坪镇","431228105":"岩桥镇","431228106":"三道坑镇","431228107":"土桥镇","431228108":"楠木坪镇","431228201":"牛牯坪乡","431228204":"水宽乡","431228212":"大树坳乡","431228215":"梨溪口乡","431228216":"洞下场乡","431228220":"禾梨坳乡","431228221":"冷水溪乡","431228223":"晓坪乡","431228224":"罗卜田乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431228.json
// module id = 1757
// module chunks = 0